import api from './axios';

export const buscarGlobal = (q) => api.get('/busca/', { params: { q } });
